export default __webpack_public_path__ + "static/media/automatic-rifles.c2251dc9.svg";